import {useEffect, useMemo, useState} from "react";
import {DRAFT_STORAGE_KEY, emptyBrief, sanitizeBrief} from "../utils/product-brief-schema";

export default function useProductBriefDraft() {
    const [brief, setBrief] = useState(emptyBrief);
    const [lastSavedAt, setLastSavedAt] = useState(null);
    const [storageAvailable, setStorageAvailable] = useState(true);
    const [restored, setRestored] = useState(false);

    useEffect(() => {
        try {
            const raw = window.localStorage.getItem(DRAFT_STORAGE_KEY);
            if (raw) {
                setBrief(sanitizeBrief(JSON.parse(raw)));
                setRestored(true);
            }
        } catch (error) {
            setStorageAvailable(false);
        }
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            saveDraft(brief);
        }, 600);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [brief]);

    const saveDraft = (value = brief) => {
        try {
            window.localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(sanitizeBrief(value)));
            setLastSavedAt(new Date());
            setStorageAvailable(true);
            return true;
        } catch (error) {
            setStorageAvailable(false);
            return false;
        }
    };

    const clearDraft = () => {
        try {
            window.localStorage.removeItem(DRAFT_STORAGE_KEY);
            setBrief(emptyBrief);
            setLastSavedAt(null);
            setRestored(false);
            setStorageAvailable(true);
            return true;
        } catch (error) {
            setStorageAvailable(false);
            return false;
        }
    };

    const savedLabel = useMemo(() => {
        if (!lastSavedAt) return "";
        return lastSavedAt.toLocaleTimeString("fa-IR", {hour: "2-digit", minute: "2-digit"});
    }, [lastSavedAt]);

    return {brief, setBrief, saveDraft, clearDraft, lastSavedAt, savedLabel, storageAvailable, restored};
}
